import React from 'react';
import {classes, style} from './doppe-action-type-price-data-view.st.css';
import {flexRowAlignToStart} from '@wix/devzai-utils-react';
import {
    DoppeActionPriceData,
    doppeActionPriceDataGetActualPrice,
    doppeActionPriceDataGetDiscountPrice,
    DoppeHideableValue,
    doppeHideableValueGetVisibleValue
} from '../../client-server-common';


export const DoppeActionTypePriceDataView = React.memo(function DoppeActionTypePriceDataView(props: DoppeActionTypePriceDataView.Props) {
    const {
        priceData,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const price = doppeHideableValueGetVisibleValue(priceData, null);

    if (price === null) {
        return null;
    }

    const actualPrice = doppeActionPriceDataGetActualPrice(price);
    const discountPrice = doppeActionPriceDataGetDiscountPrice(price);

    if (!actualPrice && !discountPrice) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                discount: discountPrice !== undefined
            }, className, flexRowAlignToStart())}
        >
            {actualPrice ? (
                <div
                    className={style(classes.actualPrice, {})}
                >
                    {actualPrice}
                </div>
            ) : null}
            {discountPrice ? (
                <div
                    className={style(classes.discountPrice, {})}
                >
                    {discountPrice}
                </div>
            ) : null}
        </div>
    );
});

export namespace DoppeActionTypePriceDataView {

    export interface Props extends React.HTMLAttributes<any> {
        priceData: DoppeHideableValue<DoppeActionPriceData>;
    }
}
